import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";

import UserCreateForm from "../components/UserCreateForm";

export default function UserCreateScreen() {
    const navigate = useNavigate();
    const { t } = useTranslation("user");

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("userCreateScreen.title")}>
                <UserCreateForm
                    onSubmitted={newId => {
                        navigate(`../${newId}`, { replace: true });
                    }}
                />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
